module.exports = __webpack_public_path__ + "static/media/bengaluru-map.7b075cc5.png";